import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ContextMenuSeparator = () => {
    return (_jsx("div", { className: "h-px my-1 mx-2", style: { backgroundColor: 'var(--pewter)' } }));
};
